import Alert from '@eduzz/houston-ui/Alert';
import { ButtonBase, Collapse, FormHelperText, Icon, TextField } from '@material-ui/core';
import StepGuide from 'components/StepGuide';
import React, { useState } from 'react';

import FaqLink from '../../Basic/FaqLink';
import styles from './styles';

interface IProps {
  handleDomain: (domain: string) => void;
  validated: boolean;
  hasDomain: boolean;
  domain: string;
  classes?: any;
  loading: boolean;
}

function DomainForm({ hasDomain, validated, handleDomain, domain, classes, loading }: IProps) {
  const faqUrl = 'https://ajuda.eduzz.com/?article=como-configurar-o-pixel-orbita';
  const message = validated
    ? 'Configurações ativas e disponíveis para uso, aproveite!'
    : 'A verificação ainda não foi realizada, aguarde um pouco mais.';

  const [handleDomainConfig, setHandleDomainConfig] = useState(false);

  return (
    <>
      <ButtonBase className={classes.expand} onClick={() => setHandleDomainConfig(!handleDomainConfig)}>
        {'Configurações de domínio  '}
        {handleDomainConfig ? <Icon fontSize='inherit'>expand_less</Icon> : <Icon fontSize='inherit'>expand_more</Icon>}
      </ButtonBase>

      <Collapse in={handleDomainConfig}>
        <div className='m8' />
        <p className={classes.font}>Para configurar seu domínio, siga os passos abaixo. Algumas das etapas são feitas fora da plataforma Eduzz.</p>
        <div className='m16' />
        <p className={classes.font}>
          1 - Configure o dominio no Gerenciador de Negócios do Facebook{' '}
          <a target='_blank' rel='noopener noreferrer' href='https://business.facebook.com/'>
            clicando aqui.&nbsp;
          </a>
          <br />
          Acesse <b>Configurações de Negócio &gt; Segurança da marca &gt; Domínios.</b>
        </p>
        <div className='m8' />
        <div className='m16' />
        <p className={classes.font}>2 - Registre seu CNAME seguindo os passos abaixo.</p>
        <div className='m8' />
        <StepGuide>
          <p className={classes.font}>
            No provedor do seu domínio vá em configurações de <span>DNS</span>
          </p>
        </StepGuide>
        <StepGuide>
          <p className={classes.font}>
            Configure seu CNAME, apontando para <span>pixel.eduzz.com</span>
          </p>
        </StepGuide>
        <StepGuide>
          <p className={classes.font}>Salve as configurações</p>
        </StepGuide>
        <div className='m16' />
        <p className={classes.font}>3 - Copie e cole aqui seu CNAME.</p>
        <TextField disabled={loading} className={classes.domainInput} value={domain} onChange={(e: any) => handleDomain(e.target.value)} />
        <FormHelperText>Ex: pixel.seudominio.com</FormHelperText>
        <div className='m16' />
        <p className={classes.font}>
          4 - A Validação será automática e assim que feita estará disponível para uso. Esse processo pode demorar até 72 horas.
        </p>
        <div className='m8' />

        {hasDomain && <Alert type={validated ? 'informative' : 'warning'}>{message}</Alert>}
        <div className={classes.centerFaq}>
          <FaqLink link={faqUrl} />
        </div>
      </Collapse>
    </>
  );
}

export default React.memo(styles(DomainForm));
